import { Badge } from "@/components/ui/badge";
import { FileText, ListTodo, FolderOpen, User } from "lucide-react";
import type { ChatSource } from "@shared/api";

const iconMap: Record<ChatSource["entity_type"], React.ElementType> = {
  note: FileText,
  task: ListTodo,
  project: FolderOpen,
  member: User,
};

const labelMap: Record<ChatSource["entity_type"], string> = {
  note: "Note",
  task: "Task",
  project: "Project",
  member: "Member",
};

interface SourcePillProps {
  source: ChatSource;
  onClick?: (source: ChatSource) => void;
}

export default function SourcePill({ source, onClick }: SourcePillProps) {
  const Icon = iconMap[source.entity_type] ?? FileText;
  const label = labelMap[source.entity_type] ?? source.entity_type;
  const title = source.title.length > 40 ? source.title.slice(0, 37) + "..." : source.title;

  return (
    <Badge
      variant="outline"
      className="cursor-pointer gap-1 border-primary/45 bg-primary/12 px-2 py-0.5 text-xs text-primary shadow-[0_0_0_1px_hsl(var(--primary)/0.15),0_0_0px_hsl(var(--primary)/0)] transition-[background-color,border-color,box-shadow,color] duration-200 ease-out hover:border-primary/65 hover:bg-primary/22 hover:shadow-[0_0_0_1px_hsl(var(--primary)/0.22),0_0_6px_hsl(var(--primary)/0.42)] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary/60"
      onClick={() => onClick?.(source)}
    >
      <Icon className="w-3 h-3 shrink-0" />
      <span className="truncate max-w-[160px]">{title}</span>
      <span className="ml-0.5 text-primary/80">{label}</span>
    </Badge>
  );
}
